// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-steel-wire/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springSteelWireEN: PageEntry = {
  id: "post.federstahldraht",
  locale: "en",
  slug: "spring-steel-wire",
  seo: {
    title: "Spring Steel Wire: Materials and Uses | Dietz GmbH",
    description:
      "Spring steel wire explained: material grades, properties and where each one is used in industrial spring manufacturing. Get a quote today.",
  },
  type: "post",
  h1: "Glossary: Spring steel wire explained simply",
  intro: "Spring steel wire is a special wire used for the production of springs. This wire is characterised by high strength, elasticity and flexibility. Spring steel wire is often made of alloy steel to ensure optimum mechanical properties. Choosing the right spring steel wire is crucial for the performance and reliability of springs in various applications, from vehicle suspensions to industrial machinery.",
  blocks: [

  ],
};
